module.exports = __webpack_public_path__ + "img/serveBanner.33f31756.jpg";